module.exports = __webpack_public_path__ + "img/icon-calenda.667d81be.svg";